module.exports = __webpack_public_path__ + "media/images/home/sales_crm-6ff160bd77979701299ab7002e204fb0.png";